<div class="d-flex justify-content-between mb-3">
  <div class="d-flex align-items-center gap-1">
    <svg
      cfIcon="chevron_down"
      class="tw:text-blue-50 tw:rotate-90 tw:cursor-pointer calendar-previous-button"
      size="sm"
      (click)="previousClicked()"
    ></svg>

    <cf-text size="xs" weight="500">{{ periodLabel }}</cf-text>

    <svg
      cfIcon="chevron_down"
      class="tw:text-blue-50 tw:-rotate-90 tw:cursor-pointer calendar-next-button"
      size="sm"
      (click)="nextClicked()"
    ></svg>
  </div>

  <cf-text size="xs" weight="500">{{ selected | dateFormat: "MMMM d, yyyy" }}</cf-text>
</div>
